import { render, staticRenderFns } from "./ModelTable.vue?vue&type=template&id=232ba03c&"
import script from "./ModelTable.vue?vue&type=script&lang=js&"
export * from "./ModelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../ceesar.portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports